import { useEffect, useState } from 'react';
import { Box, Button, Modal, ModalClose, ModalDialog, Typography } from '@mui/joy';
import { motion, useReducedMotion } from 'framer-motion';
import recoveryIllustration from '../assets/recovery-beget.webp';

export const RECOVERY_NOTICE_KEY = 'lovirds:recovery-notice:2026-11:v1';
// Показываем по 10 ноября включительно (Екатеринбург, UTC+5).
export const RECOVERY_NOTICE_END = Date.parse('2026-11-11T00:00:00+05:00');

function shouldShowNotice() {
  if (Date.now() >= RECOVERY_NOTICE_END) return false;
  try {
    return localStorage.getItem(RECOVERY_NOTICE_KEY) !== 'dismissed';
  } catch (_) {
    return true;
  }
}

/** Независим от авторизации: доступен и на входе, и внутри приложения. */
export default function RecoveryNotice() {
  const [open, setOpen] = useState(shouldShowNotice);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (!open) return undefined;
    const checkExpiry = () => {
      if (Date.now() >= RECOVERY_NOTICE_END) setOpen(false);
    };
    const timer = window.setTimeout(checkExpiry, Math.min(2147483647, Math.max(0, RECOVERY_NOTICE_END - Date.now())));
    window.addEventListener('focus', checkExpiry);
    document.addEventListener('visibilitychange', checkExpiry);
    const onStorage = (event) => {
      if (event.key === RECOVERY_NOTICE_KEY && event.newValue === 'dismissed') setOpen(false);
    };
    window.addEventListener('storage', onStorage);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('focus', checkExpiry);
      document.removeEventListener('visibilitychange', checkExpiry);
      window.removeEventListener('storage', onStorage);
    };
  }, [open]);

  const dismiss = () => {
    try { localStorage.setItem(RECOVERY_NOTICE_KEY, 'dismissed'); }
    catch (_) { /* Блокировка localStorage не мешает закрыть окно. */ }
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={dismiss} sx={{ zIndex: 15000 }}>
      <ModalDialog
        aria-labelledby="recovery-notice-title"
        aria-describedby="recovery-notice-description"
        sx={{
          width: 'calc(100% - 32px)', maxWidth: 440, maxHeight: 'calc(100dvh - 32px)',
          overflowY: 'auto', borderRadius: '28px', p: { xs: 2.5, sm: 3 },
          border: '1px solid rgba(138,77,255,.12)', backgroundColor: '#fff',
          boxShadow: '0 24px 90px rgba(62,27,98,.20)',
        }}
      >
        <ModalClose autoFocus aria-label="Закрыть уведомление" sx={{ top: 10, right: 10, borderRadius: '50%' }} />
        <Box
          component={motion.div}
          initial={reduceMotion ? false : { opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: reduceMotion ? 0 : 0.25 }}
        >
          <Box component="img" src={recoveryIllustration} alt=""
            sx={{ display: 'block', width: '100%', height: { xs: 140, sm: 165 }, objectFit: 'contain', mb: 1.5 }} />
          <Typography id="recovery-notice-title" component="h2" level="h3" sx={{ fontSize: 23, mb: 1.5 }}>
            Мы снова рядом
          </Typography>
          <Typography id="recovery-notice-description" level="body-sm" sx={{ color: '#71667d', fontSize: 14, lineHeight: 1.75 }}>
            После недавней кибератаки на серверы хостинга Beget часть данных Lovirds была утрачена.
            {' '}Мы уже восстановили часть данных и вернули сервис в работу.
            {' '}Сейчас улучшаем нашу систему, чтобы она стала надёжнее и удобнее.
            {' '}Этот опыт многому нас научил — спасибо, что остаётесь с нами.
          </Typography>
          <Button onClick={dismiss} className="lvc-grad-btn"
            sx={{ width: '100%', mt: 2.5, minHeight: 44, borderRadius: '14px' }}>
            Понял
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
}
